export default "__VITE_PUBLIC_ASSET__cc12d9bf__"